import { numberify } from "../numberify";

/**
 * getMaxNestLevel: Determine the largest DOM depth in the document or under a base element
 * @param depth Used for recursion
 */
function getMaxNestLevel(depth = 1): number {
    return document.querySelector(`${"*>".repeat(depth)}*`)
        ? getMaxNestLevel(depth + 1)
        : depth;
}

type DomStats = {
    final_dom_node_count: number;
    final_dom_nest_depth: number;
    final_html_size: number;
};

/**
 * Get stats on a DOM tree safely
 */
export function dom(): DomStats {
    try {
        return {
            final_dom_node_count: numberify(
                document.querySelectorAll("*").length,
            ),
            final_dom_nest_depth: numberify(getMaxNestLevel()),
            final_html_size: numberify(
                document.querySelector("html").outerHTML.length,
            ),
        };
    } catch (error) {
        return {
            final_dom_node_count: undefined,
            final_dom_nest_depth: undefined,
            final_html_size: undefined,
        };
    }
}
